const appWebviewTokens = {
  colors: {
    surface: '#ffffff',
    surfaceMuted: '#f9fafb',
    border: '#e5e7eb',
    borderSoft: '#d1d5db',
    textStrong: '#111827',
    text: '#374151',
    textMuted: '#6b7280',
    primary: '#3498db',
    primaryStrong: '#2563eb',
    primarySoft: '#eff6ff',
    success: '#16a34a',
    successSoft: '#f0fdf4',
    danger: '#b91c1c',
    dangerSoft: '#fef2f2',
    dangerBorder: '#fecaca',
    shadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
  },
  spacing: {
    pageY: 12,
    sectionGap: 16,
    cardPadding: 14,
    cardPaddingLg: 16,
    chipGap: 6,
  },
  radius: {
    sm: 8,
    md: 12,
    lg: 14,
    pill: 999,
  },
};

export default appWebviewTokens;
